import React, { useEffect, useState } from 'react'
import { ChevronsDown, ChevronsUp } from 'react-feather'
import { useData } from '../../Context/DataContext'
import { useNavigation } from '../../Context/NavigationContext'
import { useClaims } from '../../Context/ClaimsContext'
import { useFollowup } from '../../Context/FollowupContext'

interface SortHeaderProps {
  label: string,
  columnName: string
}

const SortHeaderComponent: React.FC<SortHeaderProps> = ({label, columnName}) => {

  const {ascending, handleSortColumnChange, handleSortOrderChange, grabRefreshClaims} = useClaims()
  const {getRefreshClaimsFollowupTwo} = useFollowup()
  const {currentSidebarTab} = useNavigation()

  const onHandleChange = () => {
    handleSortOrderChange(!ascending)
    handleSortColumnChange(columnName)
  }

  useEffect(() => {
    if(currentSidebarTab === 'Follow Up'){
      grabRefreshClaims()
    } 
  }, [ascending])

  return (
    <div className='w-full flex flex-row justify-center items-center ml-1.5 cursor-pointer hover:text-accent-teal transition-colors' onClick={() => {onHandleChange()}}>
      <p className='text-sm font-semibold text-gray-300'>{label}</p>
      {
        ascending
          ? <ChevronsUp height={18} width={18} className='text-accent-teal ml-1'/>
          : <ChevronsDown height={18} width={18} className='text-gray-400 ml-1'/>
      }
    </div>
  )
}

export default SortHeaderComponent